import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },

  getters: {
    getItems(state) {
      return state.items;
    },

    getSelectedItems(state) {
      return state.items.map(watchlist => ({
        value: watchlist.id,
        label: watchlist.name,
        id_master_account: watchlist.master_account_id,
      }));
    },
  },

  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },

  actions: {

    async getAll({ commit }, params) {
      const { data } = await axios.get("/v1/distribution-lists", { params });
      commit("setData", data.data);
      return data;
    },

    async add(_, params) {
      const { data } = await axios.post("/v1/distribution-lists", params);
      return data;
    },

    async edit(_, { id, params }) {
      const { data } = await axios.put(`/v1/distribution-lists/${id}`, params);
      return data;
    },

    async delete(_, id) {
      const { data } = await axios.delete(`/v1/distribution-lists/${id}`);
      return data;
    },

    clear({ commit }) {
      commit("setData", []);
    },
  },
};
